import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';
import { afterRender } from '../common/after-render';

/**
 * appLockInitialWidth
 * --------------------
 * Captures the element's rendered width once after the initial render cycle and locks its max-width
 * to prevent subsequent layout shifts when dynamic content (labels, async data) causes reflow.
 *
 * Usage:
 * <p-select appLockInitialWidth ...></p-select>
 *
 * Notes:
 * - Uses the shared afterRender batching utility to ensure measurement occurs post initial paint.
 * - Only sets max-width when a non-zero width is measured.
 * - Future enhancement: accept an input to choose between locking width vs max-width or re-lock on window resize.
 */
@Directive({
  selector: '[appLockInitialWidth]',
  standalone: true
})
export class LockInitialWidthDirective implements AfterViewInit {
  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    afterRender(() => {
      const host = this.el.nativeElement;
      const width = host.offsetWidth;
      if (width > 0) {
        this.renderer.setStyle(host, 'max-width', `${width}px`);
      }
    });
  }
}
